module.exports = __webpack_public_path__ + "static/media/histopathology_2.3133e8a0.jpeg";